import { useSchemesQueryState, useSelectedScheme } from "hooks/useScheme";
import type { AssetPositionNumbers } from "kubb";
import type React from "react";
import {
  AssetPositionNumbersToTable,
  computeTotalNumberOfAssetPositionsForListOfSchemes,
} from "../../../../components/AssetPosition/AssetPositionNumberSummaryList";
import BlockSpinner from "../../../../components/Spinners/BlockSpinner";
import Card, { FixHeightCardBody } from "../../../../components/Theme/card";
import { Heading } from "../../../../components/Theme/heading";

export default function AssetPositionCountWidget(): React.ReactElement {
  const selected = useSelectedScheme();
  const { schemes, loading } = useSchemesQueryState();

  const numberOfAssets: AssetPositionNumbers | undefined = selected
    ? selected.number_of_asset_positions
    : computeTotalNumberOfAssetPositionsForListOfSchemes(schemes);

  return (
    <Card title={"Asset Positions"}>
      <FixHeightCardBody height={96}>
        <BlockSpinner loading={loading}>
          {numberOfAssets ? (
            <AssetPositionNumbersToTable numbers={numberOfAssets} />
          ) : (
            <Heading>No assets yet.</Heading>
          )}
        </BlockSpinner>
      </FixHeightCardBody>
    </Card>
  );
}
